/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Querytimelabel2Inputs */

const id_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu kueri`)
};

const ms_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa pertanyaan`)
};

const da_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forespørgselstid`)
};

const de_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abfragezeit`)
};

const en_us2_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query time`)
};

const es_es2_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de consulta`)
};

const es_mx2_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de consulta`)
};

const fil_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oras ng query`)
};

const fr_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de requête`)
};

const it_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di query`)
};

const hu_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekérdezési idő`)
};

const nl_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Querytijd`)
};

const no_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søketid`)
};

const pl_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czas zapytania`)
};

const pt_br2_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de consulta`)
};

const pt_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de consulta`)
};

const ro_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timp interogare`)
};

const fi_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kyselyaika`)
};

const sv_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frågetid`)
};

const vi_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian truy vấn`)
};

const tr_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorgulama süresi`)
};

const cs_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čas dotazu`)
};

const bg_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Време на заявка`)
};

const ru_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время запроса`)
};

const uk_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Час запиту`)
};

const ar_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت الاستعلام`)
};

const hi_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्वेरी समय`)
};

const th_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาคิวรี`)
};

const ja_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クエリ時間`)
};

const zh_cn2_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查询耗时`)
};

const zh_hant1_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查詢耗時`)
};

const ko_sandboxes_querytimelabel2 = /** @type {(inputs: Sandboxes_Querytimelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쿼리 시간`)
};

/**
* | output |
* | --- |
* | "Query time" |
*
* @param {Sandboxes_Querytimelabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_querytimelabel2 = /** @type {((inputs?: Sandboxes_Querytimelabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Querytimelabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_querytimelabel2(inputs)
	if (locale === "ms") return ms_sandboxes_querytimelabel2(inputs)
	if (locale === "da") return da_sandboxes_querytimelabel2(inputs)
	if (locale === "de") return de_sandboxes_querytimelabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_querytimelabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_querytimelabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_querytimelabel2(inputs)
	if (locale === "fil") return fil_sandboxes_querytimelabel2(inputs)
	if (locale === "fr") return fr_sandboxes_querytimelabel2(inputs)
	if (locale === "it") return it_sandboxes_querytimelabel2(inputs)
	if (locale === "hu") return hu_sandboxes_querytimelabel2(inputs)
	if (locale === "nl") return nl_sandboxes_querytimelabel2(inputs)
	if (locale === "no") return no_sandboxes_querytimelabel2(inputs)
	if (locale === "pl") return pl_sandboxes_querytimelabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_querytimelabel2(inputs)
	if (locale === "pt") return pt_sandboxes_querytimelabel2(inputs)
	if (locale === "ro") return ro_sandboxes_querytimelabel2(inputs)
	if (locale === "fi") return fi_sandboxes_querytimelabel2(inputs)
	if (locale === "sv") return sv_sandboxes_querytimelabel2(inputs)
	if (locale === "vi") return vi_sandboxes_querytimelabel2(inputs)
	if (locale === "tr") return tr_sandboxes_querytimelabel2(inputs)
	if (locale === "cs") return cs_sandboxes_querytimelabel2(inputs)
	if (locale === "bg") return bg_sandboxes_querytimelabel2(inputs)
	if (locale === "ru") return ru_sandboxes_querytimelabel2(inputs)
	if (locale === "uk") return uk_sandboxes_querytimelabel2(inputs)
	if (locale === "ar") return ar_sandboxes_querytimelabel2(inputs)
	if (locale === "hi") return hi_sandboxes_querytimelabel2(inputs)
	if (locale === "th") return th_sandboxes_querytimelabel2(inputs)
	if (locale === "ja") return ja_sandboxes_querytimelabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_querytimelabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_querytimelabel2(inputs)
	return ko_sandboxes_querytimelabel2(inputs)
});
export { sandboxes_querytimelabel2 as "sandboxes.queryTimeLabel" }